<div class="container">
  <div class="row">
    <div class="offset-lg-2 col-lg-8">
      <div class="c-not-found__content">
        <img [src]="imageUrl" class="c-not-found__image">
        <div class="c-not-found__title">
          {{ 'Errors.PageNotFound.Title' | translate }}
        </div>
        <div class="c-not-found__desc">
          {{ 'Errors.PageNotFound.Desc1' | translate }}
        </div>
        <div class="c-not-found__desc" 
          innerHTML="{{ 'Errors.PageNotFound.Desc2' | translate: { link: '#', linkClass: 'c-btn c-btn--text c-btn--link-base-underline' } }}">
        </div>
      </div>
    </div>
  </div>
</div>
